import { FiCheck, FiX } from "react-icons/fi";
import { cn } from "@/lib/utils";

/** The legacy portal password regex: ≥8 chars, upper, lower, digit, special. */
export const PORTAL_PASSWORD_RULES = [
  { label: "At least 8 characters", test: (v: string) => v.length >= 8 },
  { label: "One uppercase letter", test: (v: string) => /[A-Z]/.test(v) },
  { label: "One lowercase letter", test: (v: string) => /[a-z]/.test(v) },
  { label: "One number", test: (v: string) => /\d/.test(v) },
  {
    label: "One special character",
    test: (v: string) => /[^A-Za-z0-9]/.test(v),
  },
] as const;

/** True when a password satisfies every strength rule (client-side UX check). */
export function isStrongPortalPassword(value: string): boolean {
  return PORTAL_PASSWORD_RULES.every((rule) => rule.test(value));
}

/** Live-updating strength checklist shown under a portal password field. */
export function PasswordStrengthChecklist({ value }: { value: string }) {
  return (
    <ul className="grid gap-1.5" aria-label="Password requirements">
      {PORTAL_PASSWORD_RULES.map((rule) => {
        const met = rule.test(value);
        return (
          <li
            key={rule.label}
            className={cn(
              "flex items-center gap-2 text-sm transition-colors",
              met ? "text-foreground" : "text-muted-foreground",
            )}
          >
            {met ? (
              <FiCheck className="text-primary size-4 shrink-0" aria-hidden />
            ) : (
              <FiX className="size-4 shrink-0" aria-hidden />
            )}
            <span>{rule.label}</span>
          </li>
        );
      })}
    </ul>
  );
}
